import type { SadeSatiInfo } from "@/lib/api/transits";

export type SadeSatiPhase = SadeSatiInfo["phase"] | "none";

export const SATURN_STATUS_STYLES: Record<
  SadeSatiPhase,
  { bg: string; border: string; text: string; badge: string; badgeBg: string }
> = {
  rising: {
    bg: "var(--color-warning-bg)",
    border: "var(--color-warning-tint)",
    text: "var(--color-warning-text-dark)",
    badge: "var(--color-warning-text)",
    badgeBg: "var(--color-warning-bg)",
  },
  peak: {
    bg: "var(--color-error-bg)",
    border: "var(--color-error-tint)",
    text: "var(--color-error-text)",
    badge: "var(--color-error-text-dark)",
    badgeBg: "var(--color-error-bg)",
  },
  setting: {
    bg: "var(--color-warning-bg)",
    border: "var(--color-warning-tint)",
    text: "var(--color-warning-orange-dark)",
    badge: "var(--color-warning-orange-dark)",
    badgeBg: "var(--color-warning-bg)",
  },
  none: {
    bg: "var(--color-success-bg)",
    border: "var(--color-border-valid)",
    text: "var(--color-success-text-dark)",
    badge: "var(--color-success-text-dark)",
    badgeBg: "var(--color-success-bg)",
  },
};
